import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const getBadgeColor = (position) => {
  switch (position) {
    case 1:
      return { bg: '#FFD700', text: '#000000', border: '#FFA500' }; // Gold
    case 2:
      return { bg: '#C0C0C0', text: '#000000', border: '#808080' }; // Silver
    case 3:
      return { bg: '#CD7F32', text: '#FFFFFF', border: '#8B4513' }; // Bronze
    case 4:
    case 6:
    case 8:
    case 10:
      return { bg: '#8B00FF', text: '#FFFFFF', border: '#6A00CC' }; // Purple
    case 5:
    case 7:
    case 9:
      return { bg: '#0066FF', text: '#FFFFFF', border: '#0044CC' }; // Blue
    default:
      return { bg: '#808080', text: '#FFFFFF', border: '#606060' }; // Default gray
  }
};

export function LeaderboardBadge({ position, className = "" }) {
  if (!position || position < 1 || position > 10) return null;

  const colors = getBadgeColor(position);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-flex items-center justify-center w-5 h-5 md:w-6 md:h-6 rounded-full font-bold text-xs md:text-sm ml-1.5 cursor-help ${className}`}
            style={{
              backgroundColor: colors.bg,
              color: colors.text,
              border: `2px solid ${colors.border}`,
              boxShadow: `0 0 8px ${colors.bg}80`
            }}
          >
            {position}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>Leaderboard Rank #{position}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

